import React from 'react';

import { DefaultConfig } from '../types';

const GameContext = React.createContext(DefaultConfig);

GameContext.displayName = 'GameContext';

export default GameContext;
